import React from 'react';
import PropTypes from 'prop-types';

export default function CommissionsWalletCardNavigation(props) {
  const { onClick, isNext, disabled } = props;

  if (disabled) {
    return (
      <div className="commissions-wallet-picker-cards-navigation-spacer" />
    );
  }

  return (
    <div
      className={`commissions-wallet-picker-cards-navigation ${
        isNext ? 'next' : 'prev'
      }`}
    >
      <button
        type="button"
        className="btn m-btn commissions-wallet-picker-cards-navigation-button"
        onClick={onClick}
      >
        <i className="fa fa-chevron-left" />
      </button>
    </div>
  );
}

CommissionsWalletCardNavigation.propTypes = {
  isNext: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

CommissionsWalletCardNavigation.defaultProps = {
  isNext: false,
  disabled: false,
};
